export default "__VITE_ASSET__DlQ6E8Xe__"